import apiClient from '../../shared/services/apiClient';

/**
 * New-user onboarding — /api/user/onboarding (+ optional coupon trial hint).
 */
const quiet = { skipGlobalErrorToast: true };

/** Trial eligibility from GET /api/user/coupons/summary, read defensively (missing endpoint / shape → false). */
const trialFrom = (d) => {
    if (!d || typeof d !== 'object') return false;
    const v = d.trial_eligible ?? d.cdn_trial_eligible ?? d.trial?.eligible ?? d.trial?.cdn?.eligible
        ?? d.trial_eligibility?.eligible ?? d.trial_eligibility?.cdn ?? d.eligibility?.cdn_trial;
    return v === true || v === 1;
};

const onboardingService = {
    async get(refresh = false) {
        const r = await apiClient.get('/api/user/onboarding', { ...quiet, params: refresh ? { refresh: 1 } : undefined });
        if (!r.data?.success) throw new Error(r.data?.error || 'load failed');
        return r.data.data;
    },

    /** action: 'dismiss' | 'welcome_seen' | 'nudge_dismiss' | 'focus' (+ product) */
    async mark(action, product) {
        const r = await apiClient.post('/api/user/onboarding', product ? { action, product } : { action }, quiet);
        return r.data?.data || null;
    },

    async trialEligible() {
        try {
            const r = await apiClient.get('/api/user/coupons/summary', quiet);
            return r.data?.success === false ? false : trialFrom(r.data?.data ?? r.data);
        } catch (e) {
            return false;
        }
    },
};

export default onboardingService;
